module.exports = __webpack_public_path__ + "assets/images/05-full_56ea57f9d60a1eb40080d8a878bc1ab1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatars/05-full.png
// module id = 164
// module chunks = 0